import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RiArrowDownSLine } from "react-icons/ri";
import { toast } from "react-toastify";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { TiTick } from "react-icons/ti";
import { IoClose } from "react-icons/io5";
import axios from "axios";
import { motion } from "framer-motion";

const UserAdd = () => {
  const navigate = useNavigate();

  const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
  const token = localStorage.getItem("token");

  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [mobile_phone, setMobilePhone] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedRole, setSelectedRole] = useState(null);
  const [role, setRole] = useState({});

  const [showOption, setShowOption] = useState({ stato: false, role: false });

  const states = ["Active", "Inactive"];
  // const roles = ["Venditore", "Super Admin", "Cliente Horeca", "Cliente Finale"];

  // Animation UX: Field animation
  const fieldVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.3, delay: i * 0.1 }
    })
  };

  // Animation UX: Dropdown option animation
  const optionVariants = {
    hidden: { opacity: 0, y: -5 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.2, delay: i * 0.05 }
    })
  };

  // Animation UX: Button animation
  const buttonVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.2 } }
  };

  const generateRandomPassword = () => {
    const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lowercase = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const specialChars = "!@#$%&*";

    // Ensure at least one of each required character
    let password =
      uppercase[Math.floor(Math.random() * uppercase.length)] + // At least one uppercase
      specialChars[Math.floor(Math.random() * specialChars.length)] + // At least one special character
      numbers[Math.floor(Math.random() * numbers.length)] + // At least one number
      lowercase[Math.floor(Math.random() * lowercase.length)]; // At least one lowercase

    const allCharacters = uppercase + lowercase + numbers + specialChars;

    // Fill the rest of the password with random characters
    for (let i = 4; i < 6; i++) {
      password += allCharacters[Math.floor(Math.random() * allCharacters.length)];
    }

    // Shuffle the password to mix the required characters
    return password
      .split("")
      .sort(() => Math.random() - 0.5)
      .join("");
  };

  const handleInputClick = () => {
    if (!password || password.trim().length === 0) {
      const newPassword = generateRandomPassword();
      setPassword(newPassword);
    }
  };

  const toggleDropdown = (dropdownName) => {
    setShowOption({
      stato: dropdownName === "stato" ? !showOption.stato : false,
      role: dropdownName === "role" ? !showOption.role : false,
    });
  };

  const handleStateSelect = (stato) => {
    setSelectedState(stato);
    setShowOption({ stato: false });
  };

  const handleRoleSelect = (selectedRole) => {
    setSelectedRole(selectedRole);
    setShowOption({ role: false });
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      const payload = {
        name,
        surname,
        email,
        password,
        mobile_phone,
        status: selectedState,
        role_id: selectedRole?.id,
      };
      const response = await axios.post(`${apiUrl}/api/v1/users`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      navigate("/admin/userManagement");
      toast.success(response?.message || "User created successfully!", {
        theme: "colored",
        autoClose: 1000,
      });
    } catch (error) {
      console.error("Error creating user:", error?.response?.data?.errors);
      const errors = error?.response?.data?.errors;
      if (errors) {
        for (const key in errors) {
          if (Array.isArray(errors[key])) {
            errors[key].forEach((message) => {
              toast.error(message, {
                theme: "colored",
                autoClose: 3000,
              });
            });
          }
        }
      } else {
        toast.error("Something went wrong. Please try again.", {
          theme: "colored",
          autoClose: 3000,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchRoleData = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/api/v1/roles`,
          {
            params: {
              type: "admin",
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setRole(response?.data?.data);
      } catch (error) {
        console.error("Error fetching user role data:", error);
      }
    };

    fetchRoleData();
  }, [apiUrl, token]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutsideClick = (event) => {
      if (!event.target.closest(".dropdown-container")) {
        setShowOption({ stato: false });
      }
    };
    document.addEventListener("click", handleClickOutsideClick);
    return () => {
      document.removeEventListener("click", handleClickOutsideClick);
    };
  }, []);

  return (
    <>
      <section className="border-t border-[#D9D9D9] mt-5 pt-8">
        <motion.h3
          className="text-3xl font-bold mb-4 xl:mb-5 poppins-medium"
          variants={buttonVariants}
          initial="hidden"
          animate="visible"
        >
          Aggiungi Utente
        </motion.h3>
        <div className="w-full h-auto bg-[#FCFCFC] text-left text-red-700 space-y-5bg-[#f6efef] border-[2px] border-[#8B24332B] md:p-10 p-4 rounded-xl shadow-md font-sans">
          <div className="flex flex-col space-y-4 mb-4">
            <div className="flex md:flex-row flex-col w-full gap-6">
              <motion.div
                className="flex flex-col md:w-[100%] lg:w-[50%] w-full space-y-3"
                variants={fieldVariants}
                initial="hidden"
                animate="visible"
                custom={0}
              >
                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                  Nome:
                </label>
                <input
                  type="text"
                  className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                  value={name?.replace(/[^a-zA-Z\s]/g, "").replace(/\s+/g, " ") || ""}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="inserisci il tuo nome"
                />
              </motion.div>
              <motion.div
                className="flex flex-col md:w-[50%] w-full space-y-3"
                variants={fieldVariants}
                initial="hidden"
                animate="visible"
                custom={1}
              >
                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                  Cognome:
                </label>
                <input
                  type="text"
                  className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                  value={surname?.replace(/[^a-zA-Z\s]/g, "").replace(/\s+/g, " ") || ""}
                  onChange={(e) => setSurname(e.target.value)}
                  placeholder="inserisci il tuo cognome"
                />
              </motion.div>
            </div>
            <div className="flex gap-3 md:flex-row flex-col">
              <motion.div
                className="flex flex-col md:w-[50%] w-full space-y-3 justify-end"
                variants={fieldVariants}
                initial="hidden"
                animate="visible"
                custom={2}
              >
                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                  Email:
                </label>
                <input
                  type="email"
                  className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                  value={email || ""}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="inserisci la tua email"
                />
              </motion.div>
              <div className="flex flex-col md:w-[50%] w-full relative gap-3">
                <motion.div
                  className="flex items-center gap-3"
                  variants={fieldVariants}
                  initial="hidden"
                  animate="visible"
                  custom={3}
                >
                  <label className="password-label text-sm font-semibold poppins-medium text-[#404040]">
                    Password:
                  </label>
                  <button
                    className="generate-password-button poppins-regular px-5 py-2 text-[12px] text-[#8B8B8B] rounded-[50px] bg-gray-100 border border-gray-300 hover:bg-[#8a2533] hover:text-white focus:outline-none"
                    onClick={handleInputClick}
                  >
                    Genera Password
                  </button>
                </motion.div>
                <input
                  type={showPassword ? "text" : "password"}
                  className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="inserisci la tua password"
                />
                <button
                  type="button"
                  className="absolute top-[calc(50%+22px)] right-4 text-gray-400 hover:text-gray-600 transform -translate-y-1/2"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaRegEyeSlash color="404040" /> : <FaRegEye color="404040" />}
                </button>
              </div>
            </div>
            <div className="flex gap-3 md:flex-row flex-col">
              <motion.div
                className="flex flex-col md:w-[50%] w-full gap-3"
                variants={fieldVariants}
                initial="hidden"
                animate="visible"
                custom={4}
              >
                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                  Stato:
                </label>
                <div className="relative group w-auto bg-[#FFFFFF] dropdown-container">
                  <div className="border border-gray-300 rounded-3xl">
                    <button
                      className="inline-flex justify-between items-center w-full px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent focus:outline-none relative z-10"
                      onClick={() => toggleDropdown("stato")}
                    >
                      <span className="mr-2 flex items-center gap-3 poppins-medium">
                        {selectedState === "Active" ? "Attivo" : selectedState === "Inactive" ? "Inattivo" : "Scegli stato"}
                      </span>
                      <RiArrowDownSLine
                        className={`transform transition-transform duration-300 ${showOption.stato ? "rotate-180" : ""
                          }`}
                        size={"24px"}
                        color="#9f414f"
                      />
                    </button>
                    <motion.div
                      className={`${showOption.stato ? "max-h-60 opacity-100 relative" : "max-h-0 opacity-0 overflow-hidden"
                        } bg-transparent absolute top-0 p-2 px-4 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full  transition-all duration-300 ease-in-out`}
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: showOption.stato ? 1 : 0, y: showOption.stato ? 0 : -10 }}
                      transition={{ duration: 0.2 }}
                    >
                      {states
                        .filter((states) => states !== selectedState)
                        .map((states, index, array) => (
                          <motion.label
                            key={states}
                            className={`${index !== array.length - 1 ? "border-b border-[#8b24331f]" : ""} px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn`}
                            onClick={() => handleStateSelect(states)}
                            variants={optionVariants}
                            initial="hidden"
                            animate="visible"
                            custom={index}
                          >
                            <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                              {states === "Active" ? "Attivo" : states === "Inactive" ? "Inattivo" : ""}
                            </span>
                          </motion.label>
                        ))}
                    </motion.div>
                  </div>
                </div>
              </motion.div>
              <motion.div
                className="flex flex-col md:w-[50%] w-full gap-3"
                variants={fieldVariants}
                initial="hidden"
                animate="visible"
                custom={3}
              >
                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                  Numero di cellulare:
                </label>
                <input
                  type="text"
                  className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                  value={mobile_phone}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setMobilePhone(value);
                    }
                  }}
                  placeholder="inserisci il tuo numero di cellulare"
                />
              </motion.div>
            </div>
          </div>
          <div className="flex gap-3 md:flex-row flex-col">
            <motion.div
              className="flex flex-col md:w-[calc(50%-8px)] w-full gap-3"
              variants={fieldVariants}
              initial="hidden"
              animate="visible"
              custom={5}
            >
              <label className="text-sm font-semibold poppins-medium text-[#404040]">
                Ruolo:
              </label>
              <div className="relative group w-auto bg-[#FFFFFF] dropdown-container">
                <div className="border border-gray-300 rounded-3xl">
                  <button
                    className="inline-flex justify-between items-center w-full px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent focus:outline-none relative z-10"
                    onClick={() => toggleDropdown("role")}
                  >
                    <span className="mr-2 flex items-center gap-3 poppins-medium">
                      {selectedRole?.name === "Sales Person" ? "Commerciale" : selectedRole?.name || "Scegli ruolo"}
                    </span>
                    <RiArrowDownSLine
                      className={`transform transition-transform duration-300 ${showOption.role ? "rotate-180" : ""
                        }`}
                      size={"24px"}
                      color="#9f414f"
                    />
                  </button>
                  <motion.div
                    className={`${showOption.role ? "max-h-60 opacity-100 relative" : "max-h-0 opacity-0 overflow-hidden"
                      } bg-transparent absolute top-0 p-2 px-4 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full transition-all duration-300 ease-in-out`}
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: showOption.role ? 1 : 0, y: showOption.role ? 0 : -10 }}
                    transition={{ duration: 0.2 }}
                  >
                    {Object.values(role)
                      .filter((r) => r !== selectedRole)
                      .map((r, index, array) => (
                        <motion.label
                          key={r}
                          className={`${index !== array.length - 1 ? "border-b border-[#8b24331f]" : ""} px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn`}
                          onClick={() => handleRoleSelect(r)}
                          variants={optionVariants}
                          initial="hidden"
                          animate="visible"
                          custom={index}
                        >
                          <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                            {r?.name === "Sales Person" ? "Commerciale" : r?.name}
                          </span>
                        </motion.label>
                      ))}
                  </motion.div>
                </div>
              </div>
            </motion.div>
          </div>

          <div className="flex sm:flex-row flex-col text-sm justify-start gap-4 mt-4">
            {isLoading ? (
              <motion.button
                disabled
                type="button"
                className="sm:w-[120px] w-full poppins-regular justify-center flex items-center space-x-2 p-1 px-3 bg-[#8A2533] text-white border-[1.5px] border-[#d18d97] rounded-lg transition-colors group"
                variants={buttonVariants}
                initial="hidden"
                animate="visible"
              >
                <motion.svg
                  aria-hidden="true"
                  className="w-4 h-4 text-gray-50 me-3 animate-spin dark:text-gray-600 fill-[#8B2433] invert"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </motion.svg>
                Loading...
              </motion.button>
            ) : (
              <motion.button
                className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
                onClick={handleSave}
                variants={buttonVariants}
                initial="hidden"
                animate="visible"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <TiTick size={"25px"} color="green" />
                <span className="poppins-regular">Salva</span>
              </motion.button>
            )}
            <motion.button
              className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
              onClick={() => navigate("/admin/userManagement")}
              variants={buttonVariants}
              initial="hidden"
              animate="visible"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <IoClose size={"25px"} color="red" className="group-hover:invert" />
              <span className="poppins-regular">Annulla</span>
            </motion.button>
          </div>
        </div>
      </section>
    </>
  )
};
export default UserAdd;
